import axios from 'axios';
import { getAccessToken, login, logout } from './oauth2Service.js';

// Action types
export const FETCH_CURRENT_USER_STARTED = 'pagoAuth2/fetch-current-user-started';
export const FETCH_CURRENT_USER_SUCCESS = 'pagoAuth2/fetch-current-user-success';
export const FETCH_CURRENT_USER_FAILURE = 'pagoAuth2/fetch-current-user-failure';

// Action creators
export const fetchCurrentUserStarted = () => ({
  type: FETCH_CURRENT_USER_STARTED,
});

export const fetchCurrentUserSuccess = (user) => ({
  type: FETCH_CURRENT_USER_SUCCESS,
  payload: user,
});

export const fetchCurrentUserFailure = (error) => ({
  type: FETCH_CURRENT_USER_FAILURE,
  payload: error,
  error: true,
});

// Thunk action
export const fetchCurrentUser = () => async (system) => {
  const { pagoAuth2Actions, editorActions, backendSpecsActions, backendSpecsSelectors } = system;
  const baseUrl = backendSpecsSelectors?.selectBackendBaseUrl?.() || '/api';

  pagoAuth2Actions.fetchCurrentUserStarted();

  // Check for a valid token first
  const token = getAccessToken();
  if (!token) {
    login();
    return;
  }

  try {
    const response = await axios.get(`${baseUrl}/auth/me`);
    pagoAuth2Actions.fetchCurrentUserSuccess(response.data);

    const user = response.data;

    // Lock editor for viewer roles
    const role = user?.role;
    if ((role === 'MOCKORCHESTRATOR_VIEWER' || role === 'MOCKORCHESTRATOR_VIEWER_ENV') && editorActions?.setContentReadOnly) {
      editorActions.setContentReadOnly();
    }

    // Auto-load default spec if no spec is currently in the URL
    if (user?.defaultSpecId && backendSpecsActions?.loadSpecIntoEditor) {
      // Specs are loaded via pathname (e.g., /specName)
      const pathname = window.location.pathname.replace(/^\//, '').replace(/\/$/, '');
      if (!pathname) {
        backendSpecsActions.loadSpecIntoEditor(user.defaultSpecId);
      }
    }

    return { payload: response.data };
  } catch (error) {
    if (error.response?.status === 401) {
      // Token invalid or expired - redirect to login
      login();
      return;
    }
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch user info';
    pagoAuth2Actions.fetchCurrentUserFailure(errorMessage);
    return { error: true, meta: { errorMessage } };
  }
};

export const logoutUser = () => async () => {
  logout();
};
